import * as React from "react";

/**
 * Material UI 4's Autocomplete wrapped each option in its own <li>; since MUI 5 renderOption receives the <li>
 * props first and must render the <li> itself. This adapts a v4-style `(option, state) => content` renderer.
 */
export function v4RenderOption<T, S>(render: (option: T, state: S) => React.ReactNode) {
  return (props: React.HTMLAttributes<HTMLLIElement> & { key?: React.Key }, option: T, state: S) => {
    const { key, ...liProps } = props;
    return (
      <li key={key} {...liProps}>
        {render(option, state)}
      </li>
    );
  };
}

/** Spread-safe tag props: React 19 rejects `key` inside spread props, so it is passed separately. */
export function splitKey<P extends { key?: React.Key }>(props: P): [React.Key | undefined, Omit<P, "key">] {
  const { key, ...rest } = props;
  return [key, rest];
}
